// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var triggerButtonStyles = css({
  all: 'unset',
  backgroundColor: 'transparent',
  color: 'unset',
  cursor: 'pointer',
  fontFamily: 'unset',
  fontSize: 'unset',
  fontStyle: 'unset',
  fontWeight: 'unset',
  fontVariant: 'unset',
  lineHeight: 0,
  padding: 0,
  textTransform: 'unset',
  border: '2px solid transparent',
  margin: "var(--ds-space-025, 2px)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  "&:focus-visible, &:focus-within, &[aria-expanded='true']": {
    outline: 'none',
    boxShadow: "0 0 0 2px ".concat("var(--ds-border-focused, #388BFF)"),
    borderRadius: '5px'
  }
});

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var triggerLozengeStyles = css({
  alignItems: 'center',
  display: 'flex',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  "span[role='img']": {
    margin: "var(--ds-space-negative-050, -4px)".concat(" ", "var(--ds-space-negative-100, -8px)", " ", "var(--ds-space-negative-050, -4px)", " -1px")
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var dropdownItemGroupStyles = css({
  maxHeight: '300px',
  overflowY: 'auto',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  button: {
    padding: "var(--ds-space-075, 6px)".concat(" ", "var(--ds-space-150, 12px)"),
    minHeight: '28px',
    width: '220px',
    '&:hover': {
      backgroundColor: 'inherit'
    },
    '&:focus, &:focus-visible': {
      backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
      boxSizing: 'border-box',
      boxShadow: "inset 2px 0 0 ".concat("var(--ds-border-selected, #0C66E4)"),
      outline: 'none'
    }
  }
});